module.exports = __webpack_public_path__ + "static/media/eleventh_city_hall3.7637a33b.png";